import React from 'react';
import { Section } from './Section';
import { XCircle } from 'lucide-react';
const painPoints = ['Llegás a la clase sin saber exactamente qué secuencia vas a dar hoy', 'Tus alumnos no progresan porque no tenés una estructura clara de nivel a nivel', 'El 40% abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos 10 o 15 ejercicios de siempre porque no tenés más material listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Siempre las mismas correcciones improvisadas, sin un método claro que te respalde', 'Tenés alumnos de distintos niveles juntos y la clase se convierte en un caos', 'Fin de mes y los alumnos se van sin avisar porque la comunicación es inconsistente'];
export function PainPoints() {
  return <Section className="bg-brand-dark" data-id="element-217">
      <div className="max-w-4xl mx-auto" data-id="element-218">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-center mb-6 md:mb-10 text-white" data-id="element-219">
          Si sos profe de Stretching en Argentina,{' '}
          <span className="text-red-400" data-id="element-220">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-2.5 md:space-y-3 mb-8 md:mb-12" data-id="element-221">
          {painPoints.map((point, i) => <div key={i} className="flex items-start bg-brand-light/30 p-3 md:p-4 rounded-lg border border-red-500/20" data-id="element-222">
              <XCircle className="w-5 h-5 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-223" />
              <p className="text-gray-200 text-sm md:text-base" data-id="element-224">{point}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-225">
          <h3 className="text-2xl md:text-4xl font-display font-black text-white" data-id="element-226">
            ¿Cuántas clases más vas a{' '}
            <span className="text-brand-accent underline decoration-brand-accent/50 underline-offset-4 md:underline-offset-8" data-id="element-227">
              improvisar?
            </span>
          </h3>
        </div>
      </div>
    </Section>;
}